import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { createStructuredSelector } from 'reselect';
import { selectApiKey, selectIsLoggedIn, selectMe, selectUserRights } from '../../../../../modules/Api/selectors';
import { BaseComponent } from '../../../../../components/BaseComponent';
import { Burger } from './Burger/burger';
import { HBox } from '../../../../../components/Box';
import { User } from '../../../../../components/Icon';
import { logout } from '../../../../../modules/Api/actions';
import { getUserPropertyValue } from '../../../../../modules/Users/helpers';
import { makeSelectLocale } from '../../../../LanguageProvider/selectors';
import { LAYOUT_BREAK_SMALL, UI_TOP_MENU_TOGGLE } from '../../../constants';
import { LanguageSelection } from '../../../LanguageSelection';
import { makeSelectRequireFullWidth, selectUI } from '../../../selectors';


export class TopComp extends BaseComponent {
  constructor(props) {
    super(props);
    this._lastScrollTop = 0;
  }

  get isSmall() {
    return this.props.UI.window_width <= LAYOUT_BREAK_SMALL;
  }

  get isHidden() {
    return this.props.UI.toggles[UI_TOP_MENU_TOGGLE] === false;
  }

  logout() {
    this.props.logout();
  }

  componentDidMount() {
    this.unlisten();
    this._listener = this.handleScroll.bind(this);
    window.addEventListener('scroll', this._listener);
  }

  componentWillUnmount() {
    this.unlisten();
  }

  unlisten() {
    if (!this._listener) return;
    window.removeEventListener('scroll', this._listener);
    this._listener = null;
  }

  handleScroll(event) {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0; // event.srcElement.scrollingElement.scrollTop;

    let scrollDirection = 'down';

    if (scrollTop < this._lastScrollTop) {
      scrollDirection = 'up';
    }

    this._lastScrollTop = scrollTop;

    this.setState({
      scrollDirection,
      scrollTop,
    });
  }

  renderAccountButton = () => {
    if (!this.props.apiKey?.valid) return null;
    return (
      <div className="dropdown">
        <a
          href="#"
          className="d-flex align-items-center nav-link link-primary arrow-none text-muted nav-user"
          role="button"
          id="dropdownMenuLink"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          aria-haspopup="false"
        >
          <HBox className="ps-2 pe-2" style={{ backgroundColor: '#f8f9fa', height: 70, borderLeft: '1px solid #EEF1EF' , borderRight: '1px solid #EEF1EF' }} right vCenter>
            <div className="user-icon me-1 ms-1">
              <User />
            </div>
            <span
              style={{
                display: window.innerWidth <= 575 ? 'none' : 'flex',
              }}
              className="flex-column gap-1"
            >
              <h6 className="my-0">
                {getUserPropertyValue(this.props.me, 'name', '')} {getUserPropertyValue(this.props.me, 'surname', '')}
              </h6>
              <h6 className="my-0 fw-normal">{this.props.me?.email_address || ''}</h6>
            </span>
          </HBox>
        </a>

        <ul
          className="dropdown-menu text-muted "
          aria-labelledby="dropdownMenuLink"
          style={{
            backgroundColor: 'fff',
          }}
        >
          <li className="d-flex">
            <a
              className="dropdown-item text-reset"
              href="#"
              aria-expanded="false"
              aria-haspopup="false"
              onClick={() => {
                this.props.logout();
              }}
            >
              <div className="d-flex align-items-center justify-content-start">
                <img
                  src="../../../../public/images/logout.svg"
                  style={{ width: 14, marginRight: 5, display: 'flex', marginBottom: '-2px' }}
                />
                <span>Logout</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
    );
  };

  render() {
    return (
      <div className="container-fluid sticky-top bg-white shadow-sm"  style={{ height: 70 }}>
        <header className="d-flex justify-content-end p-0 m-0 gap-4">
          {window.innerWidth <= 1440 && <Burger>{this.renderAccountButton()}</Burger>}
          <LanguageSelection />
          {this.renderAccountButton()}
        </header>
      </div>
    );
  }
}

TopComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    apiKey: selectApiKey(),
    me: selectMe(),
    loggedIn: selectIsLoggedIn(),
    fullWidth: makeSelectRequireFullWidth(),
    rights: selectUserRights(),
    UI: selectUI(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    logout() {
      dispatch(logout());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Top = compose(withConnect, withRouter)(TopComp);
